import { useCallback, useRef } from "react";
import { toast } from "@/hooks/use-toast";

export function useChatPopup() {
  const popupsRef = useRef<Map<string, Window>>(new Map());

  const openChatPopup = useCallback((spaceId: string, url?: string, options?: { width?: number; height?: number }) => {
    // If a popup for this space is already open, focus it
    const existing = popupsRef.current.get(spaceId);
    if (existing && !existing.closed) {
      existing.focus();
      return;
    }

    const width = options?.width ?? 420;
    const height = options?.height ?? 600;
    const left = window.screenX + Math.max(0, (window.outerWidth - width) / 2);
    const top = window.screenY + Math.max(0, (window.outerHeight - height) / 2);

    const popup = window.open(
      url ?? `/chat-popup?space_id=${encodeURIComponent(spaceId)}`,
      `chat-${spaceId}`,
      `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`
    );

    if (!popup || popup.closed) {
      toast({
        title: "Popup Blocked",
        description: "Please allow popups for this site to open the chat window.",
        variant: "destructive",
      });
      return;
    }

    popupsRef.current.set(spaceId, popup);

    const pollId = setInterval(() => {
      if (popup.closed) {
        clearInterval(pollId);
        popupsRef.current.delete(spaceId);
      }
    }, 500);
  }, []);

  return { openChatPopup };
}
